import React from 'react';
import { Alert, Box, Grid } from '@mui/material';
import { FormField } from '../../../../components/ui';
import { CAMPAIGN_COPY } from '../../constants/campaignCopy';

export default function BusinessServiceCreateForm({
  form,
  fieldErrors = {},
  submitError,
  onFieldChange,
}) {
  const copy = CAMPAIGN_COPY.create;

  return (
    <Box>
      {submitError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {submitError}
        </Alert>
      ) : null}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormField
            label={copy.fields.name}
            required
            value={form.name}
            onChange={(event) => onFieldChange('name', event.target.value)}
            error={Boolean(fieldErrors.name)}
            helperText={fieldErrors.name}
            autoFocus
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            label={copy.fields.tentativeBudget}
            required
            type="number"
            inputProps={{ min: 0 }}
            value={form.tentativeBudget}
            onChange={(event) => onFieldChange('tentativeBudget', event.target.value)}
            error={Boolean(fieldErrors.tentativeBudget)}
            helperText={fieldErrors.tentativeBudget}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            label={copy.fields.costOfLeads}
            required
            type="number"
            inputProps={{ min: 0 }}
            value={form.costOfLeads}
            onChange={(event) => onFieldChange('costOfLeads', event.target.value)}
            error={Boolean(fieldErrors.costOfLeads)}
            helperText={fieldErrors.costOfLeads}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
